import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';
import { IOrderCancellationRequestData } from '../../../ui-toolkit/orders/interfaces/IOrderCancellationRequest';

export interface IOrderCancellationRequestState {
  cancellationRequest?: IOrderCancellationRequestData;
  cancellationRequestFetchStatus: IFetchStatus;
  cancellationRequestError: Error | null;
  updateCancellationRequestFetchStatus: IFetchStatus;
  updateCancellationRequestError: Error | null;
}

export const orderCancellationRequestState: IOrderCancellationRequestState = {
  cancellationRequestFetchStatus: createDefaultFetch(),
  cancellationRequestError: null,
  updateCancellationRequestFetchStatus: createDefaultFetch(),
  updateCancellationRequestError: null,
};
